/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingcreatedbutsomeimagesfailedtoupload7Inputs */

const en_listingcreatedbutsomeimagesfailedtoupload7 = /** @type {(inputs: Listingcreatedbutsomeimagesfailedtoupload7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing created, but some images failed to upload`)
};

const de_listingcreatedbutsomeimagesfailedtoupload7 = /** @type {(inputs: Listingcreatedbutsomeimagesfailedtoupload7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort erstellt, aber einige Bilder konnten nicht hochgeladen werden.`)
};

/**
* | output |
* | --- |
* | "Listing created, but some images failed to upload" |
*
* @param {Listingcreatedbutsomeimagesfailedtoupload7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingcreatedbutsomeimagesfailedtoupload7 = /** @type {((inputs?: Listingcreatedbutsomeimagesfailedtoupload7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingcreatedbutsomeimagesfailedtoupload7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingcreatedbutsomeimagesfailedtoupload7(inputs)
	return de_listingcreatedbutsomeimagesfailedtoupload7(inputs)
});
export { listingcreatedbutsomeimagesfailedtoupload7 as "listingCreatedButSomeImagesFailedToUpload" }